<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('Seller-Payment-Report')}} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"  :label="this.$t('Search')"
                append-icon="search">
              </v-text-field>

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout row wrap align-center full-heigth>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items="[20,100]" :items="itemssatis"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">{{ props.item.PNR_No }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiTip }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiKod }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAd}}</td>
                                    <td class="text-xs-left">{{ props.item.Donem1 | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Donem2 | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.BA}}</td>
                                    <td class="text-xs-left">{{ props.item.HesapKodu }}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.EvrakTipi  }}</td>
                                    <td class="text-xs-left">{{ props.item.EvrakTipiAciklama }}</td>
                                    <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
                                    <td class="text-xs-center">{{ props.item.DovizCinsi }}</td>
                                    <td class="text-xs-right">{{ props.item.DovizTutar | moneyformat }}</td>
                                    <td class="text-xs-center">{{ props.item.Kur}}</td>
                                    <td class="text-xs-left">{{ props.item.CoKrediKartKod }}</td>
                                    <td class="text-xs-left">{{ props.item.Isim }}</td>
                                    <td class="text-xs-left">{{ props.item.CariUnvan}}</td>
                                    <td class="text-xs-left">{{ props.item.SatisCariKod  }}</td>
                                    <td class="text-xs-left">{{ props.item.SatisCariUnvan }}</td>
                                    <td class="text-xs-left">{{ props.item.KrediKartNo }}</td>
                                  </tr>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                  {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <yetkidialog ref="yetkidialog"></yetkidialog>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="odemeRapor.Value.PNR_No" hide-details>
                              </pnrbul>
                            </v-flex>
                            <v-flex md6 xs12 sm6>
                              <v-select clearable :items="itemssaticitip" item-text="Aciklama" item-value="Kod"
                                v-model="odemeRapor.Value.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama :autofocuss="true" apiname="SaticiAra" :tip="odemeRapor.Value.SaticiTip"
                                :label="$t('Seller-Code')" v-model="odemeRapor.Value.SaticiKod"></genelarama>
                            </v-flex>
                            {{odemeRapor.Value.SaticiKod}}

                            <v-flex xs12 sm12 md12>
                             
                                <cariaracomp v-bind:etiket="$t('Accound-Code')" v-bind:value="odemeRapor.Value.HesapKodu"
                                  v-model="odemeRapor.Value.HesapKodu" :Coper="true"></cariaracomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select :label="$t('Payment-Type')" items-value="value" item-text="text" :items="odemeItems"
                                v-model="odemeRapor.Value.OdemeTipi"></v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                            <v-layout justify-space-between column>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-layout>
                          </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>


                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../api/auth";
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../../coper/tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import cariaracomp from "@/components/app/customcomp/cariaracomp"

  export default {
    data() {
      return {
        PB:'TRY',
        tumsirketler:false,
        itemssaticitip: rez.SaticiTip,
        itemsicdis: rez.IcDis,
        itemsopsiyon: rez.Opsiyon,
        itemstarihtip: [{
          text: this.$t('Registration-Date'),
          value: 0
        }, {
          text: this.$t('Check-in-Date'),
          value: 1
        }, {
          text: this.$t('Check-out-Date'),
          value: 2
        }, {
          text: this.$t('Sales-Invoice-Date'),
          value: 3
        }, {
          text: this.$t('Commission-Invoice-Date'),
          value: 4
        }, {
          text: this.$t('Received-Invoice-Date'),
          value: 5
        }, ],

        itemskomisyon: [{
          text: this.$t('None'),
          value: false
        }, {
          text: this.$t('Available'),
          value: true
        }, {
          text: this.$t('All-v2'),
          value: null
        }],
        tarihTip: 0,

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
        filtrevarmi: false,
        search: "",
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,

        headerssatis: [{
            text: "PNR",
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Seller-Type'),
            value: "SaticiTip",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Code'),
            value: "SatıcıKod",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Seller'),
            value: "SaticiAd",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Period-v2') + "1",
            value: "Donem1",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Period-v2') + "2",
            value: "Donem2",
            width: "10%",
            align: "left"
          },
          {
            text: "BA",
            value: "BA",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Accound-Code'),
            value: "HesapKodu",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Date'),
            value: "Tarih",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Document-Type'),
            value: "EvrakTipi",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Document-Type-v3'),
            value: "EvrakTipiAciklama",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Amount'),
            value: "Tutar",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Currency'),
            value: "DovizCinsi",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Currency-Amount'),
            value: "DovizTutar",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Exchange-Rate-v2'),
            value: "Kur",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Credit-Card'),
            value: "CoKrediKartKod",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Name'),
            value: "Isim",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Title'),
            value: "CariUnvan",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Sales-Current-Code'),
            value: "SatisCariKod",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Sales-Current-Title'),
            value: "SatisCariUnvan",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Credit-Card-No'),
            value: "KrediKartNo",
            width: "10%",
            align: "left"
          }
        ],
        odemeItems: [{
            text: this.$t('All-v2'),
            value: 0,

          },
          {
            text: this.$t('Payments-Made'),
            value: 1,

          },
          {
            text: this.$t('Received-Returns'),
            value: 2,

          }
        ],
        odemeRapor: {
          Value: {
            PNR_No: null,
            SaticiTip: null,
            SaticiKod: null,
            HesapKodu: null,
            Tarih1: null,
            Tarih2: null,
            OdemeTipi: 0
          },
          Limit: null
        },

        Rapor: {
          PSirketNo: null, //eklendi
          PCariSirket: null, //eklendi
          PPNR_No: null, //eklendi
          PPNR_ParaBirimi: "TL", //eklendi
          PKayitTarihBas: null, //eklendi
          PKayitTarihBit: null, //eklendi
          PDonem1Bas: null, //eklendi
          PDonem1Bit: null, //eklendi
          PDonem2Bas: null, //eklendi
          PDonem2Bit: null, //eklendi
          PFatTarihBas: null, //eklendi
          PFatTarihBit: null, //eklendi
          PKomFatTarihBas: null, //eklendi
          PKomFatTarihBit: null, //eklendi
          PCariKod: null, //eklendi
          PSaticiTip: null, //eklendi
          PSaticiKod: null, //eklendi
          PDosyaTip: null,
          PDosya: null,
          PAcente: null,
          PPNRBir: null,
          PCariHesapGrubu: null, //eklendi
          PCariTip: null,
          PSaticiGrup: null, //eklendi
          PSaticiIc_Dis: null, //eklendi
          PTurOp: null, //eklendi
          PFaturali: null,
          POpsiyon: null, //eklendi
          PAnaTip: null, //eklendi
          PCariAnaHesap: null, //eklendi
          PIptalRaporu: null,
          PRezGrupID: null,
          PSatisGrubu: null,
          PSatisGrupTip: null,
          PSaticiOdemesiHesapla: null,
          PMasrafMerkezi: null, //eklendi
          PAcenteDepartmanID: null,
          PPozisyonNo: null,
          PSatisFaturaNo: null,
          PMusteriOdemelilerHaric: null,
          PReferans: null, //eklendi
          PSatisTip1: null,
          PSatisTip2: null,
          PSatisTip3: null,
          PSatisTip4: null,
          PGelenFatTarihBas: null, //eklen
          PGelenFatTarihBit: null, //eklendi
          PProfilSablonId: null,
          PKomisyonFaturali: null,
          PGelenFaturali: null,
        },

        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: "",
        date2: null,
        menu2: false,
        dateFormatted2: "",
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",

        renk1: "info",
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        itemsvoid: [],

        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,

    mounted() {
      this.el = this.$refs.fab.$el
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(
       window.localStorage.getItem("credentials")
    );
    this.PB=credentials.ParaBirimi;
      if (this.sayfayetki.Status == true) {



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {
            this.$validator.localize("en", this.dictionary);
            this.el = this.$refs.fab.$el;
            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var params = {
              CompanyCode: credentials.SirketKodu
            };

            this.$http
              .post(auth.API_URL + "api/currency/List", params, {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader()
                }
              })
              .then(
                response => {
                  this.doviztipi = response.body;
                },
                response => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  }
                }
              );

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },





    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      cariaracomp
    },
    watch: {},
    methods: {

      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
        var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
        window.open(url, "_target");
      },
      getList: getList,
      getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  };

  function filtrele() {
    this.dialogfiltre = true;
  }

  function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;

    this.odemeRapor.Value.PNR_No = null
    this.odemeRapor.Value.SaticiTip = null
    this.odemeRapor.Value.HesapKodu = null
    this.odemeRapor.Value.OdemeTipi = 0
    this.odemeRapor.Value.SaticiKod = null
    this.tumsirketler = false;

    this.getList();
  }

  function getList() {
    if (this.$refs.formgunluksatis.validate()) {
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);


      this.odemeRapor.Value.Tarih1 = this.KayitTarihiBasla
      this.odemeRapor.Value.Tarih2 = this.KayitTarihiBitis


      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;
        var RaporParam = {}



        RaporParam.PNR_No = this.odemeRapor.Value.PNR_No
        RaporParam.SaticiTip = this.odemeRapor.Value.SaticiTip
        RaporParam.HesapKodu = this.odemeRapor.Value.HesapKodu
        RaporParam.Tarih1 = this.odemeRapor.Value.Tarih1
        RaporParam.Tarih2 = this.odemeRapor.Value.Tarih2
        RaporParam.OdemeTipi = this.odemeRapor.Value.OdemeTipi


        if (this.odemeRapor.Value.SaticiKod != null) {
          RaporParam.SaticiKod = this.odemeRapor.Value.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = null
        }

        var params = {
          Value: RaporParam,
          Limit: null,
          tumSirketler:this.tumsirketler,
          sayfaAdi:this.$route.name
        }



        tool.http_post(this, "SaticiOdemeRaporu", params).then(
          response => {
            if (response.body.Status == true) {
              this.itemssatis = response.body.data;

              this.progress = false;
              this.load1 = true;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.progress = false;
              this.load1 = true;
            }
          },
          response => {
            this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }

  function getListExcel() {
    if (this.$refs.formgunluksatis.validate()) {
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);




      this.odemeRapor.Value.Tarih1 = this.KayitTarihiBasla
      this.odemeRapor.Value.Tarih2 = this.KayitTarihiBitis



      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;
        var RaporParam = {}



        RaporParam.PNR_No = this.odemeRapor.Value.PNR_No
        RaporParam.SaticiTip = this.odemeRapor.Value.SaticiTip
        RaporParam.HesapKodu = this.odemeRapor.Value.HesapKodu
        RaporParam.Tarih1 = this.odemeRapor.Value.Tarih1
        RaporParam.Tarih2 = this.odemeRapor.Value.Tarih2
        RaporParam.OdemeTipi = this.odemeRapor.Value.OdemeTipi


        if (this.odemeRapor.Value.SaticiKod != null) {
          RaporParam.SaticiKod = this.odemeRapor.Value.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = null
        }

        var params = {

          Value: RaporParam,
          Limit: null,
          tumSirketler:this.tumsirketler,
          sayfaAdi:this.$route.name

        }


        tool.api_post_FileDownload(this, "Coper/ExcelSaticiOdemeRaporu", params).then(
          response => {
            tool.CreateDownloadLink(response, 'CoperSaticiOdemeRaporu.xlsx');
            this.progress = false;
            this.load1 = true;


          },
          response => {
            this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }

  function beforeMount() {}
</script>
<style>
</style>